import ListTable from "common/ListTable";

const MismatchReportTable = (props) => {
  const { total, loading, defaultCurrent, pageSize, current, onChange } = props;

  return (
    <>
      <div className="table" style={{ marginTop: 10 }}>
        <ListTable
          loading={loading}
          emptyText="No records to show yet."
          pagination={{
            showSizeChanger: false,
            defaultPageSize: pageSize,
            current: current,
            onChange: onChange,
            defaultCurrent: defaultCurrent,
            total: total,
          }}
          columns={props.tableColumns}
          dataSource={props.dataSource}
          // scroll={{ x: "max-content" }}
        />
      </div>
    </>
  );
};
export default MismatchReportTable;
